"use strict";

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _helpers = require("./helpers");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DumsterFireSVG = function DumsterFireSVG(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.4 7.1l-.3.4v.1-.1c-.1.1-.2.3-.2.4l.2-.3c-.1.2-.2.3-.3.4l.1-.1c-.3.5-.5.9-.8 1.4-.7 1.3-1.1 2.6-1.1 3.6 0 1.6.4 3 1.2 4.3 0 .1.1.1.1.2l-.1-.2c.1.1.1.2.2.3v-.1c.1.1.1.2.2.3l-.1-.2c.1.1.1.2.2.3l-.1-.1c.1.1.1.2.2.3l-.1-.2c.1.1.1.2.2.3l-.1-.1c.1.1.1.2.2.3l-.2-.3c.1.1.2.2.2.3l.2.3H5.9v.7c0 .4-.3.7-.7.7H3.8h-.2c-.3-.1-.5-.4-.5-.7v-.7l-.1-1-.8-6.1H1c-.4 0-.7-.3-.7-.6V9.3c0-.4.3-.7.7-.7h.9l-.3-1.5h13.8z",
    fill: "#3963fe"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.5 5.7c.7-.8 1.5-1.7 2.4-2.5L18.3 0h-4.5v5.7h2.7zm6.6-.2c.3-.2.5-.5.8-.7l1-.8 1 .8.1.1v-.1L24.9.5c-.1-.3-.4-.5-.8-.5h-4.4l.5 2.7.5.5c.9.8 1.7 1.5 2.4 2.3zM12.4 5.7V0H7.9L6.7 5.7zM5.3 5.7L6.4 0H2c-.3 0-.6.2-.7.5L.2 4.8c-.1.5.3.9.7.9h4.4z",
    fill: "#3e4148"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.681 19.99c3.9 0 7.1-3.2 7.1-7.1 0-1.6-1.7-5-4-7.1-.6.7-1.2 1.3-1.8 1.9-.8-1.1-1.9-2.3-3.1-3.4-3.2 2.8-5.4 6.4-5.4 8.6 0 3.9 3.2 7.1 7.2 7.1z",
    fill: "#ffc400"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.681 17.89c-2.8 0-5-2.2-5-4.9 0-1 1.1-3.3 3.2-5.6 1 1.1 1.4 1.6 3.1 3.8 1.8-2.1 1.7-2.1 1.8-2.2 1.2 1.6 1.9 3.3 1.9 4 0 2.7-2.3 4.9-5 4.9z",
    fill: "#ff6f00"
  }));
};

DumsterFireSVG.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 29 20"
};

var FireSVG = function FireSVG(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.481 15.99c4 0 7.3-3.2 7.3-7.2 0-1.7-1.7-5.1-4-7.2-.7.6-1.3 1.2-1.9 1.9-.9-1.2-2-2.4-3.2-3.5-3.2 2.9-5.5 6.6-5.5 8.8 0 4 3.3 7.2 7.3 7.2z",
    fill: "#ffc400"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.481 13.79c-2.8 0-5.1-2.2-5.1-5 0-1 1.1-3.4 3.3-5.7 1 1.1 1.4 1.6 3.1 3.9 1.8-2.2 1.8-2.1 1.9-2.2 1.2 1.6 1.9 3.4 1.9 4 0 2.8-2.3 5-5.1 5z",
    fill: "#ff6f00"
  }));
};

FireSVG.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 16"
};
const {
  ContainerStyle,
  ItemRow,
  UndoContainer,
  Line
} = _styles.default;

const ItemsContainer = props => {
  const {
    onCartUpdate,
    numDeletedItems,
    testMode,
    setNumOfItems,
    env
  } = props;
  const [loaded, setLoaded] = (0, _react.useState)(false);
  const [pendingItem, setPendingItem] = (0, _react.useState)(null);
  const [deletingItems, setDeletingItems] = (0, _react.useState)([]);
  const [curDeletingItem, setCurDeletingItem] = (0, _react.useState)(false);
  const [deletedItem, setDeletedItem] = (0, _react.useState)(null);
  const [timeout, setTimeoutFunc] = (0, _react.useState)(null);
  const [cart, setCart] = (0, _react.useState)(props.cart);
  const state = {
    setPendingItem,
    pendingItem,
    setTimeoutFunc,
    timeout,
    setCurDeletingItem,
    onCartUpdate,
    testMode,
    setNumOfItems,
    setCart,
    cart,
    env
  };
  (0, _react.useEffect)(() => {
    setLoaded(true);
  }, []);
  (0, _react.useEffect)(() => {
    setCart(props.cart);
  }, [props.cart]);
  (0, _react.useEffect)(() => {
    if (curDeletingItem) {
      setDeletingItems([...deletingItems, curDeletingItem]);
    }

    setCurDeletingItem(null);
  }, [curDeletingItem]);
  (0, _react.useEffect)(() => {
    if (loaded && deletingItems.length > 0) console.log('Items set to be deleted...', deletingItems);

    if (deletingItems.length >= 1) {
      (0, _helpers.deleteItem)({
        item: deletingItems[0],
        setDeletedItem,
        testMode,
        env
      });
    }
  }, [deletingItems]);
  (0, _react.useEffect)(() => {
    if (deletedItem) {
      let newDeletingItems = _lodash.default.remove(deletingItems, i => {
        return i.Id !== deletedItem.Id && !i.deleted;
      });

      cart.CartRequisitions.forEach(cartReq => {
        if (cartReq.Supplier.Id === deletedItem.SupplierId) cartReq.Requisitions.forEach(req => {
          if (deletedItem.Id === req.Id) {
            req.deleted = true;
            console.log("Deleted item ".concat(deletedItem.Id, "."));
          }
        });
      });
      cart.CartItemTotal = cart.CartItemTotal - deletedItem.Quantity;
      setTimeout(() => {
        setDeletingItems(newDeletingItems);

        if (pendingItem.Id === deletedItem.Id) {
          setPendingItem(null);
          setDeletedItem(null);
        }

        setNumOfItems(cart.CartItemTotal);
        onCartUpdate(_objectSpread({}, cart));
      }, 1000);
    }
  }, [deletedItem]);
  return /*#__PURE__*/_react.default.createElement(ContainerStyle, null, cart.CartRequisitions.map((cartReq, cartReqIndex) => {
    const supplier = cartReq.Supplier;
    return cartReq.Requisitions.map((req, reqIndex) => {
      if (!req.deleted) {
        if (!req.SupplierId) req.SupplierId = supplier.Id;

        if (deletedItem && deletedItem.Id === req.Id) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
            key: "".concat(cartReqIndex - reqIndex)
          }, cartReqIndex + reqIndex !== 0 && /*#__PURE__*/_react.default.createElement(Line, {
            className: "collapse",
            key: "".concat(cartReqIndex - reqIndex)
          }), /*#__PURE__*/_react.default.createElement(UndoContainer, {
            className: "undo-container fade-in collapse",
            key: "".concat(supplier.Id, "-").concat(req.Id)
          }));
        } else if (deletingItems.length > 0 && _lodash.default.find(deletingItems, ['Id', req.Id])) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
            key: "".concat(cartReqIndex - reqIndex)
          }, cartReqIndex + reqIndex !== 0 && /*#__PURE__*/_react.default.createElement(Line, {
            key: "".concat(cartReqIndex - reqIndex)
          }), /*#__PURE__*/_react.default.createElement(UndoContainer, {
            className: "undo-container fade-in",
            key: "".concat(supplier.Id, "-").concat(req.Id)
          }, /*#__PURE__*/_react.default.createElement(FireSVG, {
            className: "fire-svg fade-in"
          })));
        } else if (pendingItem && pendingItem.Id === req.Id && !req.deleted) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
            key: "".concat(cartReqIndex - reqIndex)
          }, cartReqIndex + reqIndex !== 0 && /*#__PURE__*/_react.default.createElement(Line, {
            key: "".concat(cartReqIndex - reqIndex)
          }), /*#__PURE__*/_react.default.createElement(UndoContainer, {
            className: "undo-container fade-in",
            key: "".concat(supplier.Id, "-").concat(req.Id)
          }, /*#__PURE__*/_react.default.createElement(DumsterFireSVG, null), /*#__PURE__*/_react.default.createElement("p", {
            className: "micro"
          }, "This item has been removed"), /*#__PURE__*/_react.default.createElement("button", {
            onClick: () => (0, _helpers.handleUndo)({
              timeout,
              setTimeoutFunc,
              setPendingItem
            })
          }, "UNDO")));
        } else {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
            key: "".concat(cartReqIndex - reqIndex)
          }, cartReqIndex + reqIndex !== 0 && /*#__PURE__*/_react.default.createElement(Line, {
            key: "".concat(cartReqIndex - reqIndex)
          }), /*#__PURE__*/_react.default.createElement(ItemRow, {
            className: "product-row fade-in",
            key: "".concat(supplier.Id, "-").concat(req.Id)
          }, /*#__PURE__*/_react.default.createElement("img", {
            src: req.ImageUrl,
            alt: "product-image",
            onError: e => (0, _helpers.handleBrokenProductImage)(e)
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "item-details-container"
          }, /*#__PURE__*/_react.default.createElement("p", {
            className: "item-part-name"
          }, /*#__PURE__*/_react.default.createElement("b", null, req.ManufacturerName), " ", req.PartName), /*#__PURE__*/_react.default.createElement("div", {
            className: "item-qty-price"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "item-qty-container"
          }, /*#__PURE__*/_react.default.createElement("p", {
            className: "micro lite"
          }, "Qty:"), /*#__PURE__*/_react.default.createElement("input", {
            type: "number",
            value: req.Quantity,
            onChange: e => (0, _helpers.handleQuantityChange)(e, _objectSpread({
              cartReqIndex,
              reqIndex
            }, state)),
            onBlur: e => (0, _helpers.handleQuantityBlur)(e, _objectSpread({
              cartReqIndex,
              reqIndex
            }, state))
          }), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
            className: "remove-icon",
            icon: _proRegularSvgIcons.faTrashAlt,
            onClick: () => (0, _helpers.handleRemoveClick)(_objectSpread({
              item: req
            }, state))
          })), /*#__PURE__*/_react.default.createElement("div", {
            className: "item-price-container"
          }, /*#__PURE__*/_react.default.createElement("h4", {
            className: "item-price"
          }, "$", (0, _helpers.calcTotal)([req])), /*#__PURE__*/_react.default.createElement("img", {
            src: env.blobUrl + '/' + supplier.Logo,
            alt: "supplier-logo"
          }))))));
        }
      }
    });
  }));
};

var _default = ItemsContainer;
exports.default = _default;